import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import {
    faArrowUpRightFromSquare,
    faCirclePlay,
    faFile, faTrashCan, faWrench,
    faSpinner
} from "@fortawesome/pro-light-svg-icons";
import {useMutation, useQueryClient} from "react-query";
import apiService from "../../../../../../api/apiService";
import {useContext, useEffect, useState} from "react";
import RowNavigationIcon from "./RowNavigationIcon";
import {demoEnv} from "../../../../../../utils/const/query-key";
import ShareEnvironmentIcon from "../../../../../assets/createEnvAssets/ShareEnvironmentIcon";
import ModalContext from "../../ModalContext";
import {getEnvironmentURL} from "../../../createEnv/components/EnvironmentUtils";
import {TechnicalEngagementLinkUtil} from "../../TechnicalEngagementLinkUtil";

const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  color: var(--color-table-filter);

  .shared_icon {
    width: 17px;
  }
`;

const DeleteIcon = styled.button`
  font-size: 14px;
  text-decoration: none;
  color: var(--color-table-filter);
  margin: 0;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  background: none;
  border: none;
  transform: ${(props) => (props.isDeleted ? "scaleX(0)" : "")};
  opacity: ${(props) => (props.isDeleted ? "0" : "100")};

  &:hover {
    color: white;
    background-color: var(--color-brand-pink-primary);
    border-radius: 5px;
    transform: scale(1.5);
  }

  transition: all 0.3s ease-in-out;
`;

const Separator = styled.div`
  border-left: 1px solid var(--color-table-filter);
  margin: 0 15px;
`;

const RowNavigationCell = (props) => {
    const [isDeleted, setIsDeleted] = useState(false);
    const [environmentToDelete, setEnvironmentToDelete] = useState([]);
    const { deletingRowId, setDeletingRowId } = props;
    const queryClient = useQueryClient();
    const {
        setBasicModalIsOpen,
        setContentMessage,
        setEnvUrl,
        setDeleteEnvModalIsOpen,
        deleted,
        setDeleted,
        setIsEnvActive
    } = useContext(ModalContext);
    const {mutate: deleteEnv} = useMutation(
        (environment) => {
            return apiService.clearEnvironment(environment);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(demoEnv);
                setIsDeleted(false);
                setDeleted(false);
            },
        }
    );

    const handleDelete = () => {
        if (props.row.original.tokenId) {
            setContentMessage(["Active environment record cannot be cleared"]);
            setIsEnvActive(true);
        } else {
            setContentMessage(["Are you sure you want to clear this record?"]);
            setEnvironmentToDelete([props.row.original.id])
            setIsEnvActive(false);
        }
        setDeleteEnvModalIsOpen(true);
    };

    const handleStaticEnv = () => {
        setContentMessage([, , props.row.original.blueprint, props.row.original.message, props.row.original.cloudType, true]);
        setEnvUrl(props.row.original.staticLink)
        setBasicModalIsOpen(true);
    }

    useEffect(() => {
        if (deleted && environmentToDelete.length > 0) {
            setIsDeleted((current) => !current);
            setDeletingRowId(props.row.original.id);
            deleteEnv(environmentToDelete);
            setEnvironmentToDelete([]);
        }
    }, [deleted])

    return (
        <Wrapper>
            {props.row.original.technicalEngagementId && (
                <>
                    <RowNavigationIcon
                        title={"Open Technical Engagement"}
                        href={TechnicalEngagementLinkUtil(props.row.original)}
                        icon={faWrench}
                        id="openTechnicalEngagementBtn"
                    />
                    <Separator/>
                </>
            )}
            {props.row.original.inviteCustomer && (
                <>
                    <div
                        className={"shared_icon"}
                        title={"Shared with " + props.row.original.customerEmail}
                    >
                        <ShareEnvironmentIcon/>
                    </div>
                    <Separator/>
                </>
            )}
            {props.row.original.videoLink && (
                <>
                    <RowNavigationIcon
                        title={"Play video guide"}
                        href={props.row.original.videoLink}
                        icon={faCirclePlay}
                        id="PlayVideoButton"
                    />
                    <Separator/>
                </>
            )}

            <RowNavigationIcon
                title={"Guide link"}
                href={props.row.original.userGuideLink}
                icon={faFile}
                id="userGuideLinkButton"
            />

            <Separator/>
            {props.row.original.inviteCustomer === false && props.row.original.tokenId ? (
                <>
                    <RowNavigationIcon
                        title={"Open environment"}
                        href={getEnvironmentURL(props.row.original)}
                        icon={faArrowUpRightFromSquare}
                        id="openEnvironmentTokenButton"
                    />
                    <Separator/>
                </>
            ) : (
                (props.row.original.staticLink && props.row.original.status !== "Deleted") && (
                    <>
                        <RowNavigationIcon
                            title={"Open environment"}
                            onClick={handleStaticEnv}
                            icon={faArrowUpRightFromSquare}
                            id="openEnvironmentStaticButton"
                        />
                        <Separator/>
                    </>
                )
            )}
            <DeleteIcon
                id="DeleteButton"
                title="Clear Record"
                isDeleted={false}
                onClick={handleDelete}
                disabled={deletingRowId === props.row.original.id}
            >
                {deletingRowId === props.row.original.id ? (
                    <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                ) : (
                    <FontAwesomeIcon icon={faTrashCan} />
                )}
            </DeleteIcon>
        </Wrapper>
    );
};

export default RowNavigationCell;
